module.exports = __webpack_public_path__ + "media/images/sandbox/poster_opt-b8c5d6081c8c41d602074e2048b77b31.png";